module.exports = __webpack_public_path__ + "static/media/misdatosverde.e4437428.svg";